import React from 'react'
import styles from './Headline.module.css'

export const Headline = ({ children }) => <h5 className={styles.headline}>{children}</h5>